<template>
  <empty-page fillHeight>
    <v-layout column justify-center align-center>
      <div class="errorCode primary--text">Session Expired</div>
      <p class="errorDesc">
        Please login again to renew your session
      </p>
      <v-btn :to="{ name: 'dashboard' }">Go to Login</v-btn>
    </v-layout>
  </empty-page>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.errorCode {
  font-size: 5em;
}

.errorDesc {
  font-size: 1.5em;
}
</style>
